import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import ImageViewer, { ImageViewerMethods } from "./ImageViewer";

import { AssetFile } from "../../types/AssetFile";

import './AssetGallery.css'
import { Skeleton } from "primereact/skeleton";
import { AssetGalleryItem } from "./AssetGalleryItem";

import { sortBy } from "lodash";
import { useAppDispatch } from "../../hooks/storeHooks";
import { setHasEvidence } from "../../store/slices/rectificationSlice";

/**
 * AssetGallery for Asset Service
 * @param props
 * @returns
 */
export const AssetGallery = (props: {
    assets: AssetFile[];
    onDelete: (asset: AssetFile) => void;
    loading?: boolean;
    deletionState: Record<string, boolean>;
}) => {
    const { assets, onDelete, loading, deletionState } = props;
    const { t } = useTranslation("locale");
    const dispatch = useAppDispatch();

    const imageViewerRef = useRef<ImageViewerMethods | null>(null);

    useEffect(() => {
        dispatch(setHasEvidence(!!assets.length));
    }, [assets.length])

    const imageUrls = assets.reduce((urls: string[], asset) => {
        if (asset.objectURL && asset.type.includes("image")) {
            urls.push(asset.objectURL);
        }

        return urls;
    }, []);

    const onSelect = (asset: AssetFile, selectedIndex: number) => {
        const isImage = asset.type.includes("image");
    
        if (isImage) {
            if (imageViewerRef.current) {                
                imageViewerRef.current.handleImageClick(imageUrls, selectedIndex);
            }
        } else {
            const a = document.createElement('a');
            a.href = asset.objectURL;
            a.download = asset.name;
            a.click();
        }

    }

    if (loading) {
        return <Skeleton shape="rectangle" width="100%" height="204px" />;
    }

    if (!assets.length) {
        return null;
    }

    const sortedAssets = sortBy(assets, (asset) => asset.type.includes("image") ? 0 : 1);

    return (
        <>
            <div className="col-12 pb-0">
                <label>{t("assets.uploadedEvidence")}</label>
            </div>
            <div className="grid p-3 w-full">
            {sortedAssets.map((asset, index) => 
                <AssetGalleryItem key={asset.objectURL} asset={asset} onDelete={() => onDelete(asset)} onSelect={() => onSelect(asset, index)} deletionState={deletionState}/>
            )}
            </div>
            <ImageViewer ref={imageViewerRef} />
        </>
    );
};
